<template>
  <div>
    <CompTxHeaderNewPlan
      v-if="existsTransaction && txType === 'tx'"
      :transaction="transaction"
    >
    </CompTxHeaderNewPlan>
    <CompTxSelectHeaderNewPlan
      v-if="existsTransaction && txType === 'tx-select'"
      :transaction="transaction"
      :txType="txType"
      :isCancelableRefuse="isCancelableRefuse"
      :isEditableApplyComment="isEditableApplyComment"
    ></CompTxSelectHeaderNewPlan>
    <div class="relative mx-auto pb-16 px-8 xl:container">
      <div class="sp-container" style="padding-top: 150px">
        <div class="fixed pt-16" v-if="txType === 'tx'">
          <CompTxSideMenuNewPlan
            :transactionId="id"
            :transaction="transaction"
            :conciergeComment="conciergeComment"
            :adminSupplements="adminSupplements"
          />
        </div>

        <div class="sp-left-content pt-16" v-if="txType === 'tx-select'">
          <CompTxSelectSideMenuNewPlan
            :transaction="transaction"
            :transaction-service-select-id="selectId"
            :conciergeComment="conciergeComment"
            :adminSupplements="adminSupplements"
          ></CompTxSelectSideMenuNewPlan>
        </div>

        <div class="sp-main-content">
          <div
            v-if="isEditableApplyComment"
            class="text-center mb-6 sp-display-none"
          >
            <div class="font-semibold">
              <div>この案件は応募済みです。</div>
              <div>応募期限までは、応募コメントの編集ができます。</div>
            </div>
            <div class="mt-4">
              <a
                class="button-md w-80 border py-2 px-8 rounded-lg font-bold bg-white hover:button block m-auto text-gray-92"
                style="height: 40px"
                :href="
                  newNextDomain +
                  '/tx-select/' +
                  transaction.transaction_id +
                  '/application/edit'
                "
                target="_blank"
              >
                応募コメントを編集する
              </a>
            </div>
            <div class="mt-4">
              <button
                class="w-80 m-auto flex justify-center button-md text-primary-light-high px-3 py-2 rounded-lg hover:bg-primary-state-hover focus:bg-primary-state-focused active:bg-primary-state-pressed"
                style="height: 40px"
                @click="showModalApplicationWithdraw = true"
              >
                応募を取り下げる
              </button>
            </div>
          </div>
          <router-view :isCancelableRefuse="isCancelableRefuse"></router-view>
        </div>
      </div>
    </div>

    <div
      v-if="txType === 'tx'"
      class="bg-white sticky bottom-0"
      style="box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3)"
    >
      <div v-if="existsTransaction">
        <div class="xl:container mx-auto relative">
          <div class="flex items-center px-8 relative" style="height: 64px">
            <div class="flex items-center ml-auto">
              <div class="bg-white">
                <button
                  @click="showMessageModal()"
                  class="text-gray-92 flex px-14 justify-center items-center h-12 rounded-lg text-base font-bold border border-gray-38 hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10 focus:outline-none"
                >
                  <div class="mr-1">
                    <img src="@/assets/icons/MessageGray.svg" />
                  </div>
                  <div>メッセージ</div>
                  <BaseBadge
                    class="ml-4"
                    :content="transaction.unread_message_number"
                  />
                </button>
              </div>
              <button
                @click="handleToEstimateInput()"
                class="text-white flex justify-center items-center ml-2 h-12 rounded-lg text-base font-bold bg-coral-main hover:button focus:outline-none"
                style="width: 242px"
              >
                <div class="mr-1">
                  <img src="@/assets/icons/EditWhite.svg" />
                </div>
                <span v-if="!transaction.responded_at">見積もり作成</span>
                <span v-else>追加で見積もり作成</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CompTxSelectFooterButton
      v-if="existsTransaction && txType === 'tx-select'"
      :transaction="transaction"
      :transactionStatusPram="transactionStatusPram"
      @clickDecline="showDeclineEstimate = true"
    ></CompTxSelectFooterButton>
    <ModalWithdrawApplication
      :isShow="showModalApplicationWithdraw"
      @cancel="showModalApplicationWithdraw = false"
      @ok="
        showModalApplicationWithdraw = false;
        applicationWithdraw();
      "
    ></ModalWithdrawApplication>
    <ModalChargeConfirm
      :isShow="showConfirmToEstimateInput"
      @cancel="showConfirmToEstimateInput = false"
      @ok="
        showConfirmToEstimateInput = false;
        chargeConfirmRequired = false;
        agreeChargeConfirm();
        toEstimateInput();
      "
    ></ModalChargeConfirm>
    <ModalDialog
      :show-dialog="dialog.isShow"
      title=" "
      title-class="text-base"
      close-text="キャンセル"
      close-text-border-class="border"
      close-text-color-class="text-gray-62"
      close-text-bg-class="bg-white"
      ok-text="送信する"
      ok-text-color-class="text-white"
      ok-text-bg-class="bg-coral-main"
      @ok-action="validateAndSubmit()"
      @close-dialog="cancelSubmit()"
    >
      <div class="mt-10 mb-6" style="width: 500px">
        <div class="pb-4">
          <div class="font-semibold text-gray-92 my-2 text-base">
            今回の案件にマッチする理由を教えてください
            <span
              class="ml-2 text-coral-main font-semibold"
              style="font-size: 11px"
              >必須</span
            >
          </div>
          <div class="mb-6">
            <p>事務局による選定判断の参考にさせていただきます。</p>
            <p>また、当選時にカスタマーに通知されます。（上限200文字）</p>
          </div>
          <textarea
            class="block min-w-full px-4 py-3 border resize-none rounded"
            style="height: 112px; line-height: 18px"
            :class="
              dialog.isValidationError ? 'border-danger' : 'border-gray-38'
            "
            v-model="dialog.prContent"
            placeholder="当社は◯◯に強みを持つ会社であり、&#10;今回のご依頼内容に近い実績が多数ございます。&#10;実績例：〜〜〜&#10;また、ご予算の範囲内で提案が可能です。"
          ></textarea>
          <span v-show="dialog.isValidationError" class="text-danger">{{
            dialog.errorMsg
          }}</span>
        </div>
      </div>
    </ModalDialog>
    <!-- Message -->
    <transition name="fade">
      <div
        v-if="$route.meta.showMessage"
        class="fixed inset-0 z-40 w-full"
        style="background-color: rgba(0, 0, 0, 0.3)"
        @click.stop="hideMessageModal()"
      ></div>
    </transition>
    <transition name="right">
      <CompTxMessage
        v-if="$route.meta.showMessage"
        class="fixed top-0 right-0 z-50"
        :id="transaction.transaction_id"
        :company-name="transaction.buyer_company_name"
        @close="hideMessageModal()"
        @sentMessage="sentMessage()"
      ></CompTxMessage>
    </transition>
    <transition name="right">
      <CompTxDecline
        v-if="showDeclineEstimate"
        class="fixed top-0 right-0 w-full z-50"
        :id="id"
        :selectId="selectId"
        :txType="txType"
        @close="showDeclineEstimate = false"
      ></CompTxDecline>
    </transition>
  </div>
</template>

<script>
import { computed, inject, onMounted, reactive, toRefs, watch } from 'vue';
import { useRouter } from 'vue-router';
import axios from '@/utils/axiosAuth.js';
import ModalDialog from '@/components/modalDialog';
import BaseBadge from '@/components/BaseBadge.vue';
import ModalChargeConfirm from '@/components/ModalChargeConfirm.vue';
import CompTxMessage from '@/views/tx/vue/parts/CompTxMessage';
import ModalWithdrawApplication from '@/components/ModalWithdrawApplication.vue';
import CompTxDecline from '@/views/tx/vue/parts/CompTxDecline.vue';
import CompTxHeaderNewPlan from '@/views/tx/vue/parts/CompTxHeaderNewPlan';
import CompTxSelectHeaderNewPlan from '@/views/tx/vue/parts/CompTxSelectHeaderNewPlan';
import CompTxSideMenuNewPlan from '@/views/tx/vue/parts/CompTxSideMenuNewPlan';
import CompTxSelectSideMenuNewPlan from '@/views/tx/vue/parts/CompTxSelectSideMenuNewPlan';
import CompTxSelectFooterButton from '@/views/tx/vue/parts/CompTxSelectFooterButton';

import {
  attachTransactionStatusForNewPlan,
  FILTER_NOT_SELLER_RESPONDED_YET,
  FILTER_SELLER_RESPONDED_OK,
} from '@/utils/transctionSelectionStatus';

export default {
  props: {
    id: {
      required: false,
    },
    selectId: {
      required: false,
    },
  },
  components: {
    CompTxHeaderNewPlan,
    CompTxSelectHeaderNewPlan,
    CompTxSideMenuNewPlan,
    CompTxSelectSideMenuNewPlan,
    ModalWithdrawApplication,
    ModalDialog,
    BaseBadge,
    ModalChargeConfirm,
    CompTxMessage,
    CompTxDecline,
    CompTxSelectFooterButton,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const router = useRouter();
    const state = reactive({
      transaction: {},
      dialog: {
        isShow: false,
        prContent: '',
        isValidationError: false,
        errorMsg: '',
      },
      showConfirmToEstimateInput: false,
      chargeConfirmRequired: false,
      showModalApplicationWithdraw: false,
      showDeclineEstimate: false,
      transactionStatusPram: {},
      conciergeComment: {},
      adminSupplements: [],
      isCancelableRefuse: computed(() => {
        // props.idが存在する場合は/tx/xxxxのため辞退はできない
        if (props.id) {
          return false;
        }
        if (state.transaction.transaction_type === 'normal') {
          return false;
        }

        if (!state.transaction.is_refused) {
          return false;
        }

        const sendAnswerExpiredAt = new Date(
          state.transaction.send_answer_expired_at
        );
        if (sendAnswerExpiredAt.getTime() < Date.now()) {
          return false;
        }

        return true;
      }),
      isEditableApplyComment: computed(() => {
        // props.idが存在する場合は/tx/xxxxのため辞退はできない
        if (props.id) {
          return false;
        }
        if (state.transaction.transaction_type === 'normal') {
          return false;
        }

        // 応募済み
        if (!state.transaction.is_answered) {
          return false;
        }

        // 応募期限内
        const sendAnswerExpiredAt = new Date(
          state.transaction.send_answer_expired_at
        );
        if (sendAnswerExpiredAt.getTime() < Date.now()) {
          return false;
        }

        return true;
      }),
    });

    watch(state, async (state) => {
      if (state.dialog.prContent.length > 200) {
        state.dialog.isValidationError = true;
        state.dialog.errorMsg = '200文字までの入力になります';
      } else if (state.dialog.prContent.length > 0) {
        state.dialog.isValidationError = false;
        state.dialog.errorMsg = '';
      }
    });
    const route = computed(() => {
      return router.currentRoute.value;
    });
    const txType = computed(() => {
      return props.id ? 'tx' : 'tx-select';
    });
    const existsTransaction = computed(() => {
      // NOTE transactionの存在に依存している子コンポーネントがあるため力技
      return state.transaction.transaction_id ? true : false;
    });
    const getTransaction = async (id = null, targetTxType = txType.value) => {
      let path =
        targetTxType == 'tx'
          ? `/transactions/${id || props.id}/summary`
          : `/transaction-selects/${id || props.selectId}/summary`;
      const response = await axios.get(path).catch((e) => {
        globalMethods.updateModal(
          true,
          'URLが正しくないか、通信エラーが発生しました。',
          e.systemMessage || '',
          e.callback
        );
        globalMethods.sendLog(e);
      });
      if (response && response.data && response.data.data) {
        state.transaction = response.data.data.transaction;
        if (targetTxType == 'tx') {
          state.chargeConfirmRequired =
            response.data.data.is_charge_confirm_required;
        }

        state.conciergeComment = response.data.data.concierge_comment;
        state.adminSupplements = response.data.data.admin_supplements;
      }

      // 直接指名かつ、承諾済みのものは取引詳細へ遷移
      if (targetTxType === 'tx-select') {
        if (
          state.transaction.transaction_type === 'normal' &&
          state.transaction.is_answered
        ) {
          window.location = `/tx/${state.transaction.transaction_id}/summary`;
        }
        if (state.transaction.is_communication_started) {
          window.location = `/tx/${state.transaction.transaction_id}/summary`;
        }
      }
      const transactionStatusPram = attachTransactionStatusForNewPlan(
        state.transaction
      );
      state.transactionStatusPram.selectStatus =
        transactionStatusPram.selectStatus;
    };

    const validateAndSubmit = async () => {
      if (state.dialog.isValidationError) {
        return;
      }
      if (state.dialog.prContent.length === 0) {
        state.dialog.errorMsg = 'マッチ理由を入力してください。';
        state.dialog.isValidationError = true;
        return;
      }

      let postData = {
        pr_content: state.dialog.prContent,
      };
      await axios
        .post(
          `/transaction-selects/${props.selectId}/select-answer/publish`,
          postData
        )
        .then(async () => {
          globalMethods.isToast('対応希望を送りました。', { timeout: 3000 });
          // Refresh page
          router.go(0);
          window.scrollTo(0, 0);
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      state.dialog.isShow = false;
      state.dialog.prContent = '';
    };

    const cancelSubmit = () => {
      state.dialog.isShow = false;
      state.dialog.prContent = '';
      state.dialog.isValidationError = false;
      state.dialog.errorMsg = '';
    };

    const sentMessage = async () => {
      await getTransaction();
    };

    const handleToEstimateInput = () => {
      toEstimateInput();
    };

    const toEstimateInput = async () => {
      await axios
        .get(`transactions/${props.id}/est/pattern-number/latest`)
        .then((response) => {
          let resolvedRoute = router.resolve({
            name: 'EstimateInput',
            params: {
              transactionId: props.id,
              patternNumber: response.data.data.pattern_number,
            },
          });
          window.open(resolvedRoute.href, '_blank');
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };
    const applicationWithdraw = async () => {
      await axios
        .post(`transaction-selects/${props.selectId}/application/cancel`)
        .then(() => {
          // 再度募集情報を取得
          getTransaction();
          // 応募内容が削除されてなくなるので依頼概要ページに遷移
          router.push({
            name: 'TxSelectSummary',
            params: {
              selectId: props.selectId,
            },
          });
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };
    const isRouteParamChanged = (currentRouteParams, prevRouteParams) => {
      if (currentRouteParams.id && prevRouteParams.id) {
        return !(currentRouteParams.id === prevRouteParams.id);
      } else if (currentRouteParams.selectId && prevRouteParams.selectId) {
        return !(currentRouteParams.selectId === prevRouteParams.selectId);
      }
      return true;
    };
    const isRouteMessageDialogClosed = (currentRoute, prevRoute) => {
      if (
        (currentRoute === 'TxSummary' && prevRoute === 'TxSummaryMessage') ||
        (currentRoute === 'TxEstimate' && prevRoute === 'TxEstimateMessage')
      ) {
        return true;
      }
      return false;
    };
    const agreeChargeConfirm = async () => {
      await axios
        .post(`/transactions/${props.id}/charge-confirm-agreement/register`)
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const showMessageModal = () => {
      if (!state.transaction.canViewMessage) {
        return globalMethods.isToast(
          '見積もり辞退または回答期限が過ぎている為、メッセージ機能は利用できません'
        );
      }
      window.location.href = `${process.env.VUE_APP_NEW_NEXT_DOMAIN}/tx/${state.transaction.transaction_id}/messages`;
    };
    const hideMessageModal = () => {
      let name = '';
      if (route.value.meta.isTxSummary) {
        name = 'TxSummary';
      } else if (route.value.meta.isTxApplication) {
        name = 'TxApplication';
      } else if (route.value.meta.isTxEstimate) {
        name = 'TxEstimate';
        router.push({
          name: name,
          params: { patternNumber: 1 },
        });
        return;
      }
      router.push({
        name: name,
      });
    };

    onMounted(async () => {
      await getTransaction();
    });

    watch(route, (currentRoute, prevRoute) => {
      // やることリストで遷移時のデータ更新
      if (
        ([
          'TxSummary',
          'TxSummaryMessage',
          'TxSelectSummary',
          'TxEstimate',
        ].includes(currentRoute.name) &&
          isRouteParamChanged(currentRoute.params, prevRoute.params)) ||
        // 課金確認ダイアログの表示有無更新を反映するため
        isRouteMessageDialogClosed(currentRoute.name, prevRoute.name)
      ) {
        const id = currentRoute.params.id || currentRoute.params.selectId;
        const nextTxType = currentRoute.params.id ? 'tx' : 'tx-select';
        getTransaction(id, nextTxType);
      }
    });
    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    return {
      ...toRefs(state),
      sentMessage,
      handleToEstimateInput,
      toEstimateInput,
      validateAndSubmit,
      cancelSubmit,
      agreeChargeConfirm,
      applicationWithdraw,
      showMessageModal,
      hideMessageModal,
      txType,
      existsTransaction,
      FILTER_NOT_SELLER_RESPONDED_YET,
      FILTER_SELLER_RESPONDED_OK,
      newNextDomain,
    };
  },
};
</script>

<style lang="scss" scoped>
.right-enter-from,
.right-leave-to {
  transform: translateX(100vw);
}
.right-enter-active,
.right-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.sp-main-content {
  margin-left: 230px;
}

.sp-left-content {
  position: fixed;
}

@media (max-width: 640px) {
  .sp-container {
    display: flex;
    flex-direction: column;
  }
  .sp-left-content {
    position: relative;
  }
  .sp-main-content {
    margin-left: 0;
  }
  .sp-display-none {
    display: none;
  }
}
</style>
